import React from 'react'
import { defineMessage, FormattedMessage } from 'react-intl'

import {
  EligibilityInfo,
  GenerateCustomMetadata,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { UICoreFieldProps } from '../organisms/formBody/types'
import { generateDbtEligibilityMetadata as generateDbtEligibilityFields } from './registration/dbt/dbtEligibilityMetadata'
import { DbtTeenErrorBanner } from './registration/dbt/DbtTeenErrorBanner'
import { Link } from '../atoms/link/Link'

export const generateDbtEligibilityMetadata: GenerateCustomMetadata = ({ intl, eligibilityInfo }) => {
  const showTeenErrorBanner = !!eligibilityInfo.disableSubmitOnDependentSelection
  return generateDbtEligibilityFields(intl, eligibilityInfo.eligibilityQuestionTitle, showTeenErrorBanner)
}

const DbtTeenErrorBannerField = (props: UICoreFieldProps) => <DbtTeenErrorBanner {...props} />

const getCustomFields = (eligibilityInfo: EligibilityInfo) => ({
  ...(eligibilityInfo.disableSubmitOnDependentSelection ? { DbtTeenErrorBanner: DbtTeenErrorBannerField } : {}),
})

export const dbt: GetCustomerCopyFunc = ({ isDBTTeensEnabled }) => {
  return {
    generateEligibilityQuestionTitle: () =>
      defineMessage({
        defaultMessage: 'Are you looking for Dialectical Behavior Therapy (DBT) for yourself?',
        description: 'Question asking if the user is registering for DBT services for themselves',
      }),
    generateEmployeeEligibilityError: () => null,
    eligibilityMetadata: {
      generateMetadata: generateDbtEligibilityMetadata,
      getCustomFields,
    },
    userMinAgeRequirement: 18,
    customUnderageErrorWidget: 'dbtUnderageErrorBanner',
    disableSubmitOnDependentSelection: !isDBTTeensEnabled,
    showCountrySelector: true,
    sessionHistoryDescriptionText: ({ goToCareNavigatorPage }) => (
      <FormattedMessage
        defaultMessage='Reach out to our <link>Care Navigator</link> team if you need additional support with session history.'
        description='Text to inform DBT members to contact care navigator for support with session history.'
        values={{
          link: (text: string) => <Link onPress={() => goToCareNavigatorPage()} text={text} underline={true} />,
        }}
      />
    ),
  }
}
